module.exports = __webpack_public_path__ + "static/media/ppc.7133a5e2.mp4";